// hcl环境初始化，要放在组件加载之前
import { setGlobalEnv } from '@vhcl/core';

setGlobalEnv(process.env.VUE_APP_ENV_HCL, process.env.VUE_APP_HOMOLOGOUS);
